import api from "./Api";

class OrderingStoreService {
  GetConfiguration() {
    return api
      .get("/v1/OrderingStore/configuration")
      .then((response) => response.data);
  }

  SaveConfiguration(payload) {
    return api
      .put("/v1/OrderingStore/configuration", payload)
      .then((response) => response.data);
  }

  UploadAsset(type, file) {
    const formData = new FormData();
    formData.append("file", file);
    return api
      .post(`/v1/OrderingStore/assets/${type}`, formData)
      .then((response) => response.data);
  }
}

export default new OrderingStoreService();
